import { fetchAuthSession } from 'aws-amplify/auth'
import axios from 'axios';
import apiurl from "./apiweb.js"

const obj = {
    // Afecta -> /massivefacturaafecta, Exenta -> /massivefacturaexenta
    uploadFacturas: async (params, esExenta) => {
        const endpoint = esExenta ? "massivefacturaexenta" : "massivefacturaafecta";
        console.log("uploadFacturas", endpoint, params);
        const token = (await fetchAuthSession()).tokens?.idToken?.toString();
        return axios.post(apiurl + endpoint,
            params,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
                crossdomain: true
            });
    },
    downloadZip: async ({ documentos }) => {
        const token = (await fetchAuthSession()).tokens?.idToken?.toString();
        return axios.post(
            apiurl + "zipfacturasmasivas",
            { documentos },
            {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
            }
        );
    }
};

export default obj;
